import { atom, selector } from "recoil";
import CustomAxios from "../classes/CustomAxios";

export const accessTokenState = atom({
	key: "accessToken",
	default: null,
});

export const SDKState = selector({
	key: "sdk",
	get: ({get}) => {
		const accessToken = get(accessTokenState);
		if (!accessToken) return null;

		const axiosOptions = {
			baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
			timeout: 10000,
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
			retries: 3,
		};

		return new CustomAxios(axiosOptions);
	},
});
